export default function () {
  const widgetName = 'cardWidget';
  const widgetOpts = cardWidgetOpts;


  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (slide) {
      function createContentTextGallery() {
        const content = `
        <div class="blur-background">
        <div class="image-container2">
        </div>
        </div>`;
        $(content).appendTo(".image-container")
      }
      createContentTextGallery(slide)
      $(`#${widgetName} .card-widget-item`).each(function (n) {
        $(this).find(`.buttonwrap`).appendTo($(this).find('.image-container'))
        $(this).attr({
          "data-aos": 'fade-up',
          "data-aos-easing": "ease-in-out",
          "data-aos-duration": "500",
          "data-aos-delay": (n + 1) * 400,
          "data-aos-once": "true",
          
        })
        $(this).parent().attr({
          "data-aos": 'fade-up',
          "data-aos-easing": "ease-in-out",
          "data-aos-duration": "500",
          "data-aos-delay": (n + 1) * 400,
          "data-aos-once": "true",
          
        })
      });

    },
    center: true,
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: true,
      text: 'Learn MORE'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    slideshow: true, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      loop: false,
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        1024: {
          items: 3
        },
        1250: {
          items: 4
        },
      },
      autoWidth: false,
      // navText: ['Prev', 'Next'],
      nav: false,
    },
    textOverImage: false
  });
}